<template>
  <b-modal
    ref="modalDisclaimer"
    size="xl"
    scrollable
    :title="$t('Webportal.Dialog.LegalDisclaimer.Title')"   
    :ok-only="okOnly"
    :no-close-on-esc="!okOnly"
    :no-close-on-backdrop="!okOnly"
    :hide-header-close="okOnly"
    :ok-title="$t('Webportal.Dialog.LegalDisclaimer.Accept')"
    ok-variant="success"
    @ok="handleOk"
    :cancel-title="$t('Webportal.Dialog.LegalDisclaimer.Decline')"
    cancel-variant="danger"
    @hidden="handleCancel"
  >
    <span v-html="$t('Webportal.Dialog.LegalDisclaimer.Text')"></span>
  </b-modal>
</template>

<script>
export default {
  name: "LegalDisclaimer",

  mounted() {
    let disclaimer = this.$te('Webportal.Dialog.LegalDisclaimer.Text') ? (this.$t('Webportal.Dialog.LegalDisclaimer.Text') ?? '').trim() : '';

    if (disclaimer != '' &&
      (localStorage.getItem('HasUserAcceptedLegalDisclaimer') !== true.toString() || APP_TARGET === "cupra" || APP_TARGET === "porschesar") &&
      sessionStorage.getItem('HasUserAcceptedLegalDisclaimer') !== true.toString())
      this.$refs.modalDisclaimer.show();
    else
      this.redirectToTarget();
  },

  methods: {
    handleOk() {
      if (APP_TARGET === "cupra" || APP_TARGET === "porschesar")
        sessionStorage.setItem('HasUserAcceptedLegalDisclaimer', true);
      else
        localStorage.setItem('HasUserAcceptedLegalDisclaimer', true);

      this.redirectToTarget();
    },

    handleCancel() {
      this.$router.push({ name: 'unauthorized' });
    },
    okOnly(){      
      if(APP_TARGET === "porschesar") return true;
      return false;
    },

    redirectToTarget() {
      let redirectTo = this.$route.params?.redirectTo;

      if (redirectTo)
        this.$router.replace({
          path: redirectTo.path,
          query: redirectTo.query,
          replace: true
        });
      else
        this.$router.replace({ path: '/', replace: true });
    }
  }
};
</script>